import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from "@angular/core";
import { EmployeeType } from "app/shared/constants/employee-type";
import { Settings } from "app/shared/constants/settingDate.constant";
import { AuthenticationService } from "app/shared/service/authentication.service";
import { FilterDataService } from "app/shared/service/filter-date.service";
import { SharedService } from "app/shared/service/shared.service";
import { ToasterService } from "app/shared/service/toaster.service";
import { BranchDto } from "shared/service-proxies/models/branch-dto.model";
import { DepartmentDto } from "shared/service-proxies/models/department-dto.model";
import { DesignationDto } from "shared/service-proxies/models/designation-dto.model";
import { EmpNameWithCode } from "shared/service-proxies/models/emp-name-with-code.model";
import { EnumValues } from "shared/service-proxies/models/enum-values.model";
import {
    EnumValue,
    EnumValueNumber,
    FilterAccessDTO,
} from "shared/service-proxies/models/filter-dto-model";
import { FinancialYearDto } from "shared/service-proxies/models/financial-year-dto.model";
import { ITMethodDto } from "shared/service-proxies/models/it-method-dto.model";
import { LeaveDto } from "shared/service-proxies/models/leave-dto.model";
import { LocationDto } from "shared/service-proxies/models/location-dto.model";
import { SlabTypeDto } from "shared/service-proxies/models/slab-type-dto.model";
import { TransactionApplicationDto } from "shared/service-proxies/models/transaction-application-dto.model";
import { BranchServiceProxy } from "shared/service-proxies/services/branch.service";
import { CommonEnumValuesServiceProxy } from "shared/service-proxies/services/common-enum-values.service";
import { DepartmentServiceProxy } from "shared/service-proxies/services/department.service";
import { DesignationServiceProxy } from "shared/service-proxies/services/designation.service";
import { EmployeeServiceProxy } from "shared/service-proxies/services/employee.service";
import { FinancialYearServiceProxy } from "shared/service-proxies/services/financial-year.service";
import { ITSlabServiceProxy } from "shared/service-proxies/services/it-slab.service";
import { LeaveTypeServiceProxy } from "shared/service-proxies/services/leave-type.service";
import { LocationServiceProxy } from "shared/service-proxies/services/location.service";

@Component({
    selector: "app-filter",
    templateUrl: "./filter.component.html",
    styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit, OnChanges {
    @Input() filterDialog: boolean = false;
    @Input() filter: TransactionApplicationDto;
    @Input() accessFilter: FilterAccessDTO;
    @Input() employeeTypeVal: any;
    @Output() hideDialog = new EventEmitter<boolean>();
    @Output() resetDialog = new EventEmitter<TransactionApplicationDto>();
    @Output() submitDialogs = new EventEmitter<TransactionApplicationDto>();
    @Input() isFromAdminAttendanceReport: boolean = false;

    dateFormat = Settings.dateFormat;
    timeFormat = Settings.timeFormat;
    calendarDateFormat = Settings.calendarDateFormat;
    monthFormat = Settings.monthPickerFormat;

    employees: EmpNameWithCode[];
    branchs: BranchDto[];
    departments: DepartmentDto[];
    designations: DesignationDto[];
    appStatus: EnumValues[];
    approver: EmpNameWithCode[];
    leaveType: LeaveDto[];
    activeStatus: EnumValueNumber[];
    activeEmployeeStatus: EnumValueNumber[];
    employeeType: EnumValueNumber[];
    gender: EnumValue[];
    locations: LocationDto[];
    itMethod: ITMethodDto[];
    slabType: SlabTypeDto[];
    financialYear: FinancialYearDto[];

    constructor(
        private empService: EmployeeServiceProxy,
        private branchService: BranchServiceProxy,
        private deptService: DepartmentServiceProxy,
        private designationService: DesignationServiceProxy,
        private enumService: CommonEnumValuesServiceProxy,
        private leaveTypeServiceProxy: LeaveTypeServiceProxy,
        private _toasterService: ToasterService,
        private _sharedService: SharedService,
        private _locationService: LocationServiceProxy,
        private _authenticationService: AuthenticationService,
        private _itSlabServiceProxy: ITSlabServiceProxy,
        private _financialYearServiceProxy: FinancialYearServiceProxy,
        private filterDataService: FilterDataService,
        private SharedService: SharedService
    ) {
        // this.arrayOfActiveData();
        this._sharedService.onFilteChange.subscribe((isOpen) => {
            this.submitDialog();
        });
    }

    ngOnInit(): void {
        this.arrayOfActiveData();
        this.getEmployeeWithCode(this.employeeTypeVal);
        this.getActiveBranches();
        this.getActiveDepartments();
        this.getActiveLocations();
        this.getActiveDesignation();
        this.getApproverWithCode();
        this.getLeaveType();
        this.defaultValue();
        this.getApplicationStatus();
        this.getFinancialYearService();
        this.getAllSlabType();
        this.getAllITMethod();
    }

    ngOnChanges(): void {}

    arrayOfActiveData() {
        this.activeStatus = [
            { name: "All", value: -1 },
            { name: "Pending", value: 0 },
            { name: "Approve", value: 1 },
            { name: "Reject", value: 2 },
        ];

        if (this.isFromAdminAttendanceReport) {
            this.activeEmployeeStatus = [
                { name: "Active", value: 1 },
                { name: "All", value: -1 },           
                { name: "Inactive", value: 0 },
            ];
        }
        else {
            this.activeEmployeeStatus = [
                { name: "All", value: -1 },           
                { name: "Active", value: 1 },
                { name: "Inactive", value: 0 },
            ];
        }

        this.gender = [
            { name: "All", value: "" },
            { name: "Male", value: "male" },
            { name: "Female", value: "female" },
            { name: 'Other', value: "Other" },
        ];
        this.employeeType = [
            { name: "All", value: 0 },
            { name: "Employee", value: 1 },
            { name: "Permanent", value: 2 },
        ];
    }

    onResetDialog() {
        this.defaultValue();
        this.resetDialog.emit(this.filter);
    }

    defaultValue() {
        this.filter.employeeCode = null;
        this.filter.employeeIds = null;
        this.filter.gender = null;
        this.filter.branchIds = null;
        this.filter.locationIds = null;
        this.filter.departmentIds = null;
        this.filter.designationIds = null;
        this.filter.mobileNo = null;
        this.filter.approverIds = null;
        this.filter.financialYear = null;
        this.filter.slabTypeId = null;
        this.filter.itMethodId = null;

        // this.filter.employeeStatus = this.filterDataService.isAdmin();
        // this.filter.applicationStatus =this.filterDataService.isAdmin();
        if (this.filter.fromMonth)
            this.filter.fromMonth = this.filterDataService.fromMonth();
        if (this.filter.toMonth)
            this.filter.toMonth = this.filterDataService.toMonth();
        if (this.filter.fromDate)
            this.filter.fromDate = this.filterDataService.firstDayDate();
        if (this.filter.toDate)
            this.filter.toDate = this.filterDataService.toDayDate();
    }

    onHideFilterDialog() {
        this.filterDialog = false;
        this.hideDialog.emit(this.filterDialog);
    }

    getEmployeeWithCode(employeeType) {
        if(employeeType == null) employeeType = EmployeeType.EMPLOYEE;
        this.empService.getEmployeeWithCode(0,employeeType).subscribe((response) => {
            if (response.isSuccess) {
                this.employees = response.responseData;
            } else {
                this._toasterService.toastWarning(response.errorMessage);
            }
        });
    }

    getApproverWithCode() {
        this.empService.getAllApprovableEmployees().subscribe((response) => {
            if (response.isSuccess) {
                this.approver = response.responseData;
            } else {
                this._toasterService.showApiValidation(response);
            }
        });
    }

    getActiveBranches() {
        this.branchService.getActiveBranches().subscribe((response) => {
            if (response.isSuccess) {
                this.branchs = response.responseData;
            } else {
                this._toasterService.toastWarning(response.errorMessage);
            }
        });
    }
    getActiveLocations() {
        this._locationService.getActiveLocations().subscribe((response) => {
            if (response.isSuccess) {
                this.locations = response.responseData;
            } else {
                this._toasterService.toastWarning(response.errorMessage);
            }
        });
    }

    getActiveDepartments() {
        this.deptService.getActiveDepartments().subscribe((response) => {
            if (response.isSuccess) {
                this.departments = response.responseData;
            } else {
                this._toasterService.toastWarning(response.errorMessage);
            }
        });
    }

    getActiveDesignation() {
        this.designationService.getActiveDesignation().subscribe((response) => {
            if (response.isSuccess) {
                this.designations = response.responseData;
            } else {
                this._toasterService.toastWarning(response.errorMessage);
            }
        });
    }

    getLeaveType() {
        this.leaveTypeServiceProxy
            .getActiveLeaveTypes()
            .subscribe((response) => {
                if (response.isSuccess) {
                    this.leaveType = response.responseData;
                } else {
                    this._toasterService.showApiValidation(response);
                }
            });
    }

    getApplicationStatus() {
        this.enumService.getAllTransactionStatus().subscribe((response) => {
            if (response.isSuccess) {
                this.appStatus = response.responseData;
            } else {
                this._toasterService.toastWarning(response.errorMessage);
            }
        });
    }

    getAllITMethod() {
        this._itSlabServiceProxy.getAllITMethod().subscribe((response) => {
            if (response.isSuccess) {
                this.itMethod = response.responseData;
            } else {
                this._toasterService.showApiValidation(response);
            }
        });
    }

    getAllSlabType() {
        this._itSlabServiceProxy.getAllSlabType().subscribe((response) => {
            if (response.isSuccess) {
                this.slabType = response.responseData;
            } else {
                this._toasterService.showApiValidation(response);
            }
        });
    }

    getFinancialYearService() {
        this._financialYearServiceProxy
            .getFinancialYears()
            .subscribe((response) => {
                if (response.isSuccess) {
                    this.financialYear = response.responseData;
                }
            });
    }

    submitDialog() {
        this.submitDialogs.emit(this.filter);
    }
}
